import React, {useState} from 'react';
import { GoogleMap, LoadScript, Marker, Polyline } from '@react-google-maps/api';
import CustomMapControl from './CustomMapControl';
import NOxEmissionsElectricityGeneratorsData from './NOxEmissionsElectricityGeneratorsData';
//const NOX_EMISSIONS_DATA = 
// , Longitude:  , Longitude:
const WINDS = [
    [
        {lat: 45.09169, lng: -91.19724},
        {lat: 51.07138, lng: -73.61911}
    ],
    [
        {lat: 39.27900, lng: -84.64931},
        {lat: 49.10620, lng: -66.32411}
    ],
    [
        {lat: 39.56522, lng: -77.11607},
        {lat: 45.11703, lng: -69.21643}
    ]
];
const calculateScale = (value) => {
    // 3750 -> 0.2, 11250 -> 0.8
    /*
    if (value < 3749) {
        return 0.2;
    }
    if (value < 7499) {
        return 0.4
    }
    if (value < 11249) {
        return 0.6
    }
    return 0.8;
    */
   return 0.0001 * value;
};

const calculateColor = (value) => {
    if (value < 3749) {
        return '#9e3d22';
    }
    if (value < 7499) {
        return '#ea6f22'
    }
    if (value < 11249) {
        return '#6196c3'
    }
    return '#2b5c8a'
};

const SvgIcon = (props) => {
    const color = props.color;
    const scale = props.scale;
    //const spaces = 4 - scale / 0.2;
    return (<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={60 * scale} height={60 * scale}>
        <circle r={25 * scale} cx={30 * scale} cy={30 * scale} style={{
            fill: color,
            stroke: 'gray',
            strokeWidth: 1
        }} />
    </svg>);
};

const SvgLine = (props) => {
    return (<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={60} height={20}>
        <polygon points="4,8 4,12 29,12 29,16, 39.392,10 29,4 29,8" style={{
            fill: `#e9d751`,
            stroke: 'gray',
            strokeWidth: 0
        }} />
    </svg>)
};
const NOxEmissionsElectricityGeneratorsMap = (props) => {
    const [plants, setPlants] = useState([]);
    const [winds, setWinds] = useState([]);

    return (
            <div style={{height: "740px"}} className="App">
                <h6 style={{textAlign: "center"}}>{props.title}</h6>
                <LoadScript id="script-loader" googleMapsApiKey={window.API_KEY} language="en" region="ca">
                <GoogleMap
                    id='example-map'
                    mapContainerClassName="App-map"
                    zoom={5}
                    center={{
                        lat: 45.01,
                        lng: -82.323214,
                    }}
                    onLoad={map => {
                        //console.log(map);
                        //console.log(map.getBounds());
                        setPlants(NOxEmissionsElectricityGeneratorsData);
                        setWinds(WINDS);
                    //setMap(map);
                    //const bounds = new window.google.maps.LatLngBounds();
                    //map.fitBounds(bounds);
                    }}
                >
                    <CustomMapControl>
                        <div style={{backgroundColor:'#ffffff',borderStyle:'solid',borderWidth:'10px',borderColor:'#ccc',marginTop:'5px',marginLeft:'5px'}}>
                            <h6>Legend</h6>
                            <div><abbr title="nitrogen oxides">NO{"\u2093"}</abbr> Emissions, tonnes</div>
                            <div style={{width: "200px", textAlign: "center"}}>
                                <SvgIcon color={calculateColor(0.5 * (11250 + 15000))} scale={calculateScale(0.5 * (11250 + 15000)) * 0.8 }/>&nbsp;&nbsp;11,250&nbsp;-&nbsp;15,000
                            </div>
                            <div style={{width: "200px", textAlign: "center"}}>
                                <SvgIcon color={calculateColor(0.5 * (7500 + 11249))} scale={calculateScale(0.5 * (7500 + 11249)) * 0.8 }/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7,500&nbsp;-&nbsp;11,249
                            </div>
                            <div style={{width: "200px", textAlign: "center"}}>
                                <SvgIcon color={calculateColor(0.5 * (3750 + 7499))} scale={calculateScale(0.5 * (3750 + 7499)) * 0.8 }/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3,750&nbsp;-&nbsp;7,499
                            </div>
                            <div style={{width: "200px", textAlign: "center"}}>
                                <SvgIcon color={calculateColor(0.5 * (0 + 3749))} scale={calculateScale(0.5 * (0 + 3749)) * 0.8 }/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;&nbsp;3,749
                            </div>
                            <div style={{width: "200px", textAlign: "center"}}>
                                <SvgLine/>Prevailing Winds
                            </div>
                            <div style={{width: "200px", textAlign: "center"}}>
                                Circles sized relative to emissions
                            </div>
                        </div>
                    </CustomMapControl>
                    {
                        plants.map((plant, index) =>
                            <Marker 
                                key={index} 
                                position={plant}
                                title={`${plant.NOx.toFixed(2)} tonnes`}
                                icon={{
                                    path: "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
                                    fillColor: calculateColor(plant.NOx),
                                    fillOpacity: .99,
                                    //anchor: new window.google.maps.Point(0,0),
                                    strokeWeight: 0.5,
                                    scale: calculateScale(plant.NOx)
                                }}/>
                        )
                    }
                    {
                        winds.map((wind, index) => 
                            <Marker 
                            key={index} 
                            position={wind[1]}
                            icon={{
                                path: 'M 10,50 L 35,93 L 60,50 z', //"M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
                                fillColor: `#e9d751`,
                                fillOpacity: .7,
                                anchor: new window.google.maps.Point(30,70),
                                strokeWeight: 0,
                                scale: 1.5,
                                clickable: false
                            }}/>            
                        )
                    }
                    {
                        winds.map((wind, index) => 
                            <Polyline key={index} path={wind} 
                            options={{
                                strokeColor: `#e9d751`,
                                strokeOpacity: 0.7,
                                strokeWeight: 30,
                                geodesic: true,
                                clickable: false,
                                editable: false,
                                zIndex: 1,
                            }} />
                        )
                    }
                </GoogleMap>
                </LoadScript>
            </div>
     );
  };
  export default NOxEmissionsElectricityGeneratorsMap;
